import camelCaseDotString from '@/utils/camel-case-dot-string';

export default function (errorMessages) {
  const camelCaseErrorMessages = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const key in errorMessages) {
    // eslint-disable-next-line no-prototype-builtins
    if (errorMessages.hasOwnProperty(key)) {
      const message = errorMessages[key];
      camelCaseErrorMessages[camelCaseDotString(key)] = message;
    }
  }
  return camelCaseErrorMessages;
}
